import {NEXTCognitoUser} from "../../../types";
import getUuid from 'uuid-by-string';
import {NextCloudIdentityProvider} from "../../accounts/types.ts";

export const convertFromTMSUserToUser = (record: NEXTCognitoUser, emailAddress: string) => {
    let nextCloudIdentityProvider = undefined;

    if (
        typeof record['federated-id-providers'] !== 'undefined' &&
        Array.isArray(record['federated-id-providers']) &&
        record['federated-id-providers'].length > 0
    ) {
        nextCloudIdentityProvider = record['federated-id-providers'][0] as NextCloudIdentityProvider;
    }

    const recordId = getUuid(emailAddress);
    console.debug('recordId', recordId)

    return Object.assign(
        {},
        {
            id: recordId,

            name: record['name'],
            email: emailAddress,

            username: record['username'],
            cognitoUserPoolDomain: record['cognito-user-pool-domain'],
            appClientId: record['app-client-id'],
            description: record['description'],
            callbackUrls: record['callback-urls'],
            icaoCode: record['icao-code'],
            cognitoUserPoolId: record['cognito-user-pool-id'],
            federatedIdProviders: record['federated-id-providers'] as NextCloudIdentityProvider[],
            firstName: record['first-name'],
            lastName: record['last-name'],
            emailAddress: emailAddress,
            nextcloudIdentityProvider: nextCloudIdentityProvider,
            isAuthorizing: 'no',
            isVisible: 'yes',
        }
    );
};
